import { Injectable } from '@angular/core';
import { ParentApiService } from './parent-api-service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CreateDocRequestDto } from '../entities/doc-entities/create-doc-request-dto';
import { CreateDocFailedResponseDto } from '../entities/doc-entities/create-doc-failed-response-dto';
import { CreateDocTdRequestDto } from '../entities/doc-entities/create-doc-td-request';
import { PaginationQueryDto } from '../entities/pagination-query-dto';
import { PaginationResponseDto } from '../entities/pagination-response-dto';
import { PpwrPackagingInfoDto } from '../entities/ppwr-entities/ppwr-packaging-info-dto';
import { SetPpwrApprovedRequestDto } from '../entities/ppwr-entities/set-ppwr-approved-request-dto';
import { DataExchangeRequestStatusDto } from '../entities/data-exchange-request-entities/data-exchange-request-status-dto';
import { TechnicalDocumentationStatusDto } from '../entities/ppwr-entities/technical-documentation-status-dto';

@Injectable({
  providedIn: 'root',
})
export class PpwrApiService extends ParentApiService {
  private readonly baseUrl = environment.webApiAddress + '/api';

  constructor(private readonly http: HttpClient) {
    super();
  }

  getDocProblemsForUnits(packages: CreateDocTdRequestDto, stayOnPageIfError?: boolean): Observable<CreateDocFailedResponseDto[]> {
    console.log('getDocProblemsForUnits request:', packages);
    return this.http.post<CreateDocFailedResponseDto[]>(`${this.baseUrl}/packaging-units/doc/problem-information`, packages, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
    });
  }

  getDocProblemsForSystems(packages: CreateDocTdRequestDto, stayOnPageIfError?: boolean): Observable<CreateDocFailedResponseDto[]> {
    return this.http.post<CreateDocFailedResponseDto[]>(`${this.baseUrl}/packaging-systems/doc/problem-information`, packages, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
    });
  }

  generateTechnicalDocumentationForUnits(packages: CreateDocTdRequestDto, stayOnPageIfError?: boolean): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/packaging-units/generate-technical-documentation`, packages, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
      responseType: 'blob',
    });
  }

  generateTechnicalDocumentationForSystems(packages: CreateDocTdRequestDto, stayOnPageIfError?: boolean): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/packaging-systems/generate-technical-documentation`, packages, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
      responseType: 'blob',
    });
  }

  generateDocForUnits(request: CreateDocRequestDto, stayOnPageIfError?: boolean): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/packaging-units/generate-doc`, request, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
      responseType: 'blob',
    });
  }

  generateDocForSystems(request: CreateDocRequestDto, stayOnPageIfError?: boolean): Observable<Blob> {
    return this.http.post(`${this.baseUrl}/packaging-systems/generate-doc`, request, {
      headers: stayOnPageIfError ? this.stayOnPageIfErrorHeader : this.emptyHeader,
      responseType: 'blob',
    });
  }

  getPpwrInfoForSystemsByPage(paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<PpwrPackagingInfoDto>> {
    return this.http.post<PaginationResponseDto<PpwrPackagingInfoDto>>(`${this.baseUrl}/packaging-systems/ppwr-info/by-page`, paginationQuery);
  }

  getPpwrInfoForUnitsByPage(paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<PpwrPackagingInfoDto>> {
    return this.http.post<PaginationResponseDto<PpwrPackagingInfoDto>>(`${this.baseUrl}/packaging-units/ppwr-info/by-page`, paginationQuery);
  }

  setPpwrApprovedForSystem(request: SetPpwrApprovedRequestDto): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/packaging-systems/set-ppwr-approved`, request);
  }

  setPpwrApprovedForUnit(request: SetPpwrApprovedRequestDto): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/packaging-units/set-ppwr-approved`, request);
  }
}
